module.exports = __webpack_public_path__ + "1c865d442c711aa63dbc741e6f47b6df.jpg";